import { colors } from '@configs/styles/config'
import styled from '@emotion/styled'
import { Button } from '@nextui-org/react-latest'
import { useTranslation } from 'react-i18next'

type Props = {
  onBtnClick: () => void
}

const InviteNow = ({ onBtnClick }: Props) => {
  const { t } = useTranslation('referrals')
  return (
    <Container>
      <Title>{t('invite_section.title')}</Title>
      <Button
        className="px-16 font-regular max-w-max text-xl py-8"
        radius="full"
        color="primary"
        onClick={onBtnClick}
      >
        {t('invite_section.button_text')}
      </Button>
    </Container>
  )
}

export default InviteNow

const Container = styled.div`
  max-width: 1420px;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  margin: 4rem auto;
  align-items: center;
  @media (max-width: 1400px) {
    padding: 0rem 1rem;
  }
`
const Title = styled.div`
  font-family: var(--font-roboto);
  font-weight: 700;
  font-size: 48px;
  line-height: 65px;
  width: 1100px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: ${colors.uguPurple};
  @media (max-width: 1280px) {
    font-size: 42px;
    line-height: 60px;
    width: 80%;
  }
  @media (max-width: 769px) {
    font-size: 36px;
    line-height: 48px;
    width: 90%;
  }
`
